document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.getElementById("mobile-menu-open-btn") || document.querySelector(".menu-button.w-nav-button");
  const offcanvas = document.getElementById("mobile-offcanvas-menu");
  const closeBtn = document.getElementById("mobile-menu-close-btn");
  const backdrop = document.getElementById("mobile-menu-backdrop");

  if (!offcanvas) return;

  function openMenu() {
    offcanvas.classList.add("is-open");
    offcanvas.setAttribute("aria-hidden", "false");
    if (menuBtn) {
      menuBtn.setAttribute("aria-expanded", "true");
      menuBtn.classList.add("w--open");
    }
    document.body.classList.add("mobile-nav-open");
  }

  function closeMenu() {
    offcanvas.classList.remove("is-open");
    offcanvas.setAttribute("aria-hidden", "true");
    if (menuBtn) {
      menuBtn.setAttribute("aria-expanded", "false");
      menuBtn.classList.remove("w--open");
    }
    document.body.classList.remove("mobile-nav-open");
  }

  if (menuBtn) {
    menuBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (offcanvas.classList.contains("is-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closeMenu();
    });
  }

  if (backdrop) {
    backdrop.addEventListener("click", function () {
      closeMenu();
    });
  }

  // Close when clicking any menu link
  offcanvas.querySelectorAll(".mobile-offcanvas__link, .mobile-offcanvas__sublink").forEach(function (link) {
    link.addEventListener("click", function () {
      closeMenu();
    });
  });

  // Close when opening cart from inside drawer
  const drawerCartBtn = offcanvas.querySelector(".mobile-offcanvas__cart-btn");
  if (drawerCartBtn) {
    drawerCartBtn.addEventListener("click", function () {
      closeMenu();
    });
  }

  // Toggle submenus
  offcanvas.querySelectorAll(".mobile-offcanvas__toggle-sub").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const parentItem = btn.closest(".mobile-offcanvas__item");
      if (!parentItem) return;
      const sublist = parentItem.querySelector(".mobile-offcanvas__sublist");
      const isExpanded = parentItem.classList.toggle("sub-expanded");
      if (sublist) {
        sublist.style.display = isExpanded ? "block" : "none";
      }
    });
  });

  // ESC key to close
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && offcanvas.classList.contains("is-open")) {
      closeMenu();
    }
  });

  // Swatch label live updater
  document.addEventListener("change", function (e) {
    if (e.target && e.target.classList.contains("variant-radio-input")) {
      const group = e.target.closest(".variant-option-group");
      if (group) {
        const selectedValEl = group.querySelector(".variant-selected-value");
        if (selectedValEl) {
          selectedValEl.textContent = e.target.value;
        }
      }
    }
  });

  // Reset if resized to desktop
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 992 && offcanvas.classList.contains("is-open")) {
      closeMenu();
    }
  });
});





$(document).ready(function () {
  //============================================
  const topBars = $(".top-bar");
  let currentIndex = 0;

  function toggleOpacity() {
    topBars.removeClass("opacity-100").addClass("opacity-0");
    topBars.eq(currentIndex).removeClass("opacity-0").addClass("opacity-100");
    currentIndex = (currentIndex + 1) % topBars.length;
    setTimeout(toggleOpacity, 3000); // Adjust the delay as needed
  }

  toggleOpacity();



  //============================================
  // Set default opacity for all tab buttons
  $("[data-tabs-target]").css("opacity", 0.5);

  // Hide all tabs except the first one
  $('[id^="default-tab-content"] > div:not(:first)').addClass("hidden");

  // Find the first button with aria-selected="true" and update styles
  var $initialTab = $("[data-tabs-target]").filter('[aria-selected="true"]');
  $initialTab.css("opacity", 1.0).addClass("border-b");

  // Handle tab button click
  $("[data-tabs-target]").on("click", function () {
    // Hide all tab content
    $('[id^="default-tab-content"] > div').addClass("hidden");

    // Show the selected tab content
    $($(this).data("tabs-target")).removeClass("hidden");

    // Update tab button styles
    $("[data-tabs-target]").css("opacity", 0.5).removeClass("border-b");
    $(this).css("opacity", 1.0).addClass("border-b");
  });

  //=====================================
  // Click event for the buttons
  $(".radio-select").on("click", function () {
    // Remove the 'hidden' class from all spans
    $(".radio-select span").addClass("hidden");

    // Get the index of the clicked button
    var index = $(this).index() + 1;

    // Remove the 'hidden' class from the corresponding span
    $(".selection-text")
      .eq(index - 1)
      .find("span")
      .removeClass("hidden");
  });
  //=====================================
  // Wait for the document to be ready

  //=====================================
  // Function to set height based on screen width
  function setHeightBasedOnWidth() {
    // Check the device width
    if ($(window).width() >= 768) {
      // Get the height of the content inside the first class
      var tabContentHeight = $(".tab-wrapper-inner").outerHeight();

      // Set the height of the second class based on the content height
      $(".default-tab-content").css("height", tabContentHeight);
    } else {
      // If the width is less than 768px, reset the height to auto or any desired value
      $(".default-tab-content").css("height", "auto");
    }
  }

  // Initial height setting
  setHeightBasedOnWidth();

  // Listen for window resize events
  $(window).resize(function () {
    // Update height when the window is resized
    setHeightBasedOnWidth();
  });
  //=====================================
  var defaultTab = $("#default-tab");
  var buttons = defaultTab.find(".tab-btn");

  // Show the tab-data of the first button by default
  var firstButton = buttons.first();
  var firstTabData = firstButton.find(".tab-data");
  firstTabData.animate({ height: "toggle" });

  buttons.on("click", function () {
    var clickedButton = $(this);
    var targetTabData = clickedButton.find(".tab-data");

    // Check if the clicked tab is already active
    var isAlreadyActive = targetTabData.is(":visible");

    // Hide all tab-data elements with height animation
    $(".tab-data").not(targetTabData).animate({ height: "hide" });

    // Show the tab-data of the clicked button if it's not already active
    if (!isAlreadyActive) {
      targetTabData.animate({ height: "toggle" });
    }
  });
  //============================================
  $(".btn-review").click(function () {
    // Find the reviews-wrapper element
    var reviewsWrapper = $(".reviews-wrapper");

    // Replace the height class
    reviewsWrapper.removeClass("h-[40rem]").addClass("h-auto");

    // Find the review-shadow element and add the hidden class
    reviewsWrapper.find(".review-shadow").addClass("hidden");

    // Add the hidden class to the button
    $(this).hide();
  });
  //============================================
  // Target the contact form
  var contactForm = $(".type-form");

  // Attach a function to the change event on input and textarea elements within the form
  contactForm.find("input, textarea").on("input", function () {
    // Find the corresponding field wrapper for the current input or textarea
    var fieldWrapper = $(this).closest("[field-wrapper]");

    // Check if the input or textarea has a value
    if ($(this).val().trim() !== "") {
      // Add the not-empty class to the field wrapper
      fieldWrapper.addClass("not-empty");
    } else {
      // Remove the not-empty class from the field wrapper
      fieldWrapper.removeClass("not-empty");
    }
  });

  //=================================
  // Add click event listener to each details element
  $("details").on("click", function () {
    // Close all other details elements
    $("details").not(this).removeAttr("open");
  });

  //================================
  $(".js-toggle-accordion").click(function (e) {
    e.preventDefault(); // Prevent the default behavior of the anchor tag

    var container = $(this).next(".set-details-container");
    var arrow = $(this).find(".set-details-arrow"); // Look for .set-details-arrow within the clicked element

    // Toggle the visibility of the set-details-container
    container.toggleClass("expanded");
    var maxHeight = container.hasClass("expanded") ? container[0].scrollHeight + "px" : "0";
    container.css("max-height", maxHeight);

    // Add or remove classes based on the presence of 'expanded' class
    arrow.toggleClass("transform rotate-180 transition-all duration-300 ease", container.hasClass("expanded"));
  });

  // Hide the login prompt by default
  $(".login-prompt").addClass("hidden");

  // Show login prompt when prompt-btn is clicked
  $(".prompt-btn").click(function () {
    $(".login-prompt").removeClass("hidden");
  });

  // Hide login prompt when prompt-close is clicked
  $(".prompt-close").click(function () {
    $(".login-prompt").addClass("hidden");
  });




});

$(document).ready(function () {
  // Listen for changes in the data-added attribute of any .product-card
  $(".product-card").on("DOMSubtreeModified", function () {
    var hasDataAdded = false;
    // Loop through each .product-card
    $(".product-card").each(function () {
      // Check if the current .product-card has the data-added attribute
      if ($(this).attr("data-added")) {
        hasDataAdded = true;
        return false; // Exit the loop if data-added attribute is found
      }
    });
    // Check if any .product-card has data-added attribute
    if (hasDataAdded) {
      // If any .product-card has data-added attribute, add hidden class to .skip-button
      $(".skip-button").addClass("hidden");
    } else {
      // If no .product-card has data-added attribute, remove hidden class from .skip-button
      $(".skip-button").removeClass("hidden");
    }
  });
});

$(document).ready(function () {
  // Initialize a variable to store the maximum height
  var maxHeight = 0;

  // Iterate over each .flip-box-content to find the maximum height
  $(".flip-box-content").each(function () {
    // Get the current height of the flip-box-content
    var currentHeight = $(this).outerHeight();

    // Update maxHeight if the current height is greater
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });

  // Apply the maximum height to all .flip-box elements
  $(".flip-box").css("height", maxHeight);
  $(".flip-box-content").css("height", maxHeight);
});

function generateWave(element) {
  let wave = document.querySelector(element);
  if (wave) {
    const width = wave.getBoundingClientRect().width;
    const height = wave.getBoundingClientRect().height;
    const offset = height - 50;
    const amplitude = width < 500 ? 15 : 25;
    const frequency = width < 500 ? 0.7 : 1.1;
    const phase = width < 500 ? -50 : -80;
    const points = 30;
    const inverted = true;
    const units = (2 * Math.PI * frequency) / points;
    const path = "clip-path: polygon(100% 100%, 0% 100% ";
    const invertedpath = "clip-path: polygon(100% 0%, 0% 0% ";

    let clipPathString = path;
    if (inverted) clipPathString = invertedpath;

    let radPhase = (phase * Math.PI) / 180;

    for (let i = 0; i <= points; i++) {
      let val = offset + amplitude * Math.cos(i * units + radPhase);
      let valY = ((val / height) * 100).toFixed(2);
      let valX = ((i * 100) / points).toFixed(2);
      clipPathString += ", " + valX + "% " + valY + "%";
    }
    clipPathString += ");";
    wave.style = clipPathString;
  }
}

(() => {
  generateWave(".wave-container");
})();

new WOW().init();

(function ($) {
  "use strict";

  //Update Header Style and Scroll to Top
  function headerStyle() {
    if ($(".main-header").length) {
      var windowpos = $(window).scrollTop();
      var siteHeader = $(".main-header");
      var scrollLink = $(".scroll-to-top");
      var HeaderHight = $(".main-header").height();
      if (windowpos >= HeaderHight) {
        siteHeader.addClass("fixed-header");
        scrollLink.fadeIn(300);
      } else {
        siteHeader.removeClass("fixed-header");
        scrollLink.fadeOut(300);
      }
    }
  }

  headerStyle();

  //Mobile Nav Hide Show
  if ($(".mobile-menu").length) {
    var mobileMenuContent = $(".header-lower .menu_area .main-menu").html();
    $(".mobile-menu .menu-box .menu-outer").append(mobileMenuContent);
    $(".sticky_header .main-menu").append(mobileMenuContent);
    $(".mobile-menu li.dropdown .dropdown-btn").on("click", function () {
      $(this).toggleClass("open");
      $(this).prev("ul").slideToggle(500);
    });
    $(".mobile-menu li.dropdown .dropdown-btn").on("click", function () {
      $(this).prev(".megamenu").slideToggle(900);
    });
    $(".mobile-nav-toggler").on("click", function () {
      $("body").addClass("mobile-menu-visible");
    });
    $(".mobile-menu .menu-backdrop,.mobile-menu .close-btn").on("click", function () {
      $("body").removeClass("mobile-menu-visible");
    });
  }

  //Add One Page nav
  if ($(".scroll-nav").length) {
    $(".scroll-nav ul").onePageNav();
  }

  //Custom Scroll Links / Sidebar
  if ($(".scroll-nav li a").length) {
    $(".scroll-nav li a").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("mobile-menu-visible");
    });
  }

  // Animation Fade Left End
  /////////////////////////////////////////////////////
  // CURSOR
  var cursor = $(".cursor"),
    follower = $(".cursor-follower");

  var posX = 0,
    posY = 0;

  var mouseX = 0,
    mouseY = 0;

  TweenMax.to({}, 0.016, {
    repeat: -1,
    onRepeat: function () {
      posX += (mouseX - posX) / 9;
      posY += (mouseY - posY) / 9;

      TweenMax.set(follower, {
        css: {
          left: posX - 12,
          top: posY - 12,
        },
      });

      TweenMax.set(cursor, {
        css: {
          left: mouseX,
          top: mouseY,
        },
      });
    },
  });

  $(document).on("mousemove", function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  $(".theme-btn, a").on("mouseenter", function () {
    cursor.addClass("active");
    follower.addClass("active");
  });
  $(".theme-btn, a").on("mouseleave", function () {
    cursor.removeClass("active");
    follower.removeClass("active");
  });

  if ($(".animation_mode").length) {
    $(".animation_mode").marquee({
      speed: 50,
      gap: 20,
      delayBeforeStart: 0,
      direction: "left",
      duplicated: true,
      pauseOnHover: true,
      startVisible: true,
    });
  }

  // Elements Animation
  if ($(".wow").length) {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  }

  document.addEventListener("mousemove", (e) => {
    const cursor = document.querySelector(".cursor-wrapp");
    const follower = document.querySelector(".cursor-follower");
    cursor.style.top = `${e.clientY}px`;
    cursor.style.left = `${e.clientX}px`;
    follower.style.top = `${e.clientY}px`;
    follower.style.left = `${e.clientX}px`;
  });

  // ================================
  // SMOKE EFFECT INTEGRATION
  // ================================
  const canvas = document.createElement("canvas");
  canvas.id = "smoke-canvas";
  canvas.style.position = "fixed";
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.zIndex = "9999";
  canvas.style.pointerEvents = "none";
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  let width = window.innerWidth;
  let height = window.innerHeight;
  canvas.width = width;
  canvas.height = height;

  window.addEventListener("resize", () => {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
  });

  const particles = [];
  const mouse = { x: width / 2, y: height / 2 };

  document.addEventListener("mousemove", (e) => {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
    particles.push(new Particle(mouse.x, mouse.y));
    if (Math.random() < 0.15) {
      particles.push(new Particle(mouse.x, mouse.y, true));
    }
  });

  class Particle {
    constructor(x, y, isOrange = false) {
      this.x = x;
      this.y = y;
      this.isOrange = isOrange;
      this.radius = isOrange ? Math.random() * 2 + 1 : Math.random() * 3 + 2.5;
      this.alpha = isOrange ? 0.8 : 0.3;
      this.dx = (Math.random() - 0.5) * (isOrange ? 1.2 : 0.6);
      this.dy = (Math.random() - 0.5) * (isOrange ? 1.2 : 0.6);
      this.fade = isOrange ? 0.02 : 0.004 + Math.random() * 0.003;
      this.color = isOrange ? "255, 102, 0" : "60, 60, 60";
    }

    update() {
      this.x += this.dx;
      this.y += this.dy;
      this.alpha -= this.fade;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${this.color}, ${this.alpha})`;
      ctx.fill();
    }
  }

  function animate() {
    ctx.clearRect(0, 0, width, height);
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.update();
      if (p.alpha <= 0) {
        particles.splice(i, 1);
      } else {
        p.draw();
      }
    }
    requestAnimationFrame(animate);
  }

  animate();

  // When document is scrolling
  $(window).on("scroll", function () {
    headerStyle();
  });
})(window.jQuery);
